import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import SEO from "../../../utils/SEO";

export default function GoldenVisaItaly() {

    return (
        <main className='main'>
            <SEO
                title="Italy Golden Visa | Residency by Investment Program "
                description=" Obtain Italian residency through the Investor Visa. Gain EU access, Schengen travel, family inclusion, and a pathway to citizenship. "
                keywords="Italy Golden Visa, Italy investor visa, Italy residency by investment, EU residency Italy, Schengen visa Italy, Italy immigration program, investment visa Italy, Italy citizenship pathway "
                url="/golden-visa-italy"
            />
            <IntroSection
                title="Residency by Investment – Italy"
                subtitle="Residency by Investment in the Heart of Europe"
                description="The Italian Golden Visa (Investor Visa) allows investors and entrepreneurs to obtain residency in Italy through a range of investment options. With its world-class lifestyle, EU market access, and Schengen mobility, Italy is one of the most attractive destinations for those seeking both opportunity and culture."
                badges={[
                    "EU Residency",
                    "Schengen Free Travel",
                    "Family Included",
                    "Path to Citizenship"
                ]}
                buttonText="Request a Golden Visa Italy Consultation →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/residency-passport/golden-visa-italy-hero.png")}
                imageAlt="Italy Golden Visa & Residency"
            />
            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose the Italian Golden Visa?'
                        blocks={[
                            {
                                items: [
                                    { title: "Schengen Mobility", text: "Visa-free travel across 27 EU countries." },
                                    { title: "Residency Rights", text: "Live, work, and study in Italy." },
                                    { title: "Family Benefits", text: "Includes spouse, children, and dependent parents." },
                                    { title: "Flexible Investments", text: "Capital, government bonds, startups, or philanthropy." },
                                    { title: "Pathway to Citizenship", text: "Permanent residency leading to citizenship in 10 years." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Investment Options"
                        blocks={[
                            {
                                title: "1. Government Bonds",
                                items: [
                                    { text: "Invest €2 million+ in Italian government bonds." }
                                ]
                            },
                            {
                                title: "2. Italian Companies",
                                items: [
                                    { text: "Invest €500,000+ in an existing Italian company." }
                                ]
                            },
                            {
                                title: "3. Innovative Startups",
                                items: [
                                    { text: "Invest €250,000+ in an approved Italian startup." }
                                ]
                            },
                            {
                                title: "4. Philanthropic Donation",
                                items: [
                                    { text: "Contribute €1 million+ to cultural, educational, or public interest projects." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title='Key Features'
                        blocks={[
                            {
                                items: [
                                    { title: "Residency Permit", text: "Initially valid for 2 years, renewable for 3 years." },
                                    { title: "Flexible Stay", text: "No minimum physical stay requirement to maintain the permit." },
                                    { title: "Permanent Residency", text: "Eligible after 5 years." },
                                    { title: "Citizenship Eligibility", text: "After 10 years for Italian & EU citizenship." },
                                    { title: "Healthcare & Education", text: "Access to public healthcare and education systems." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title="Benefits of Italy’s Golden Visa"
                        services={[
                            { title: "Live in Italy", text: "Enjoy one of the world’s most desirable lifestyles." },
                            { title: "Schengen Access", text: "Freedom of travel across the EU." },
                            { title: "Family Residency", text: "Include spouse, children, and parents under the visa." },
                            { title: "Diverse Investment Routes", text: "Choose from startups, bonds, companies, or philanthropic donations." },
                            { title: "Permanent Residency & Citizenship", text: "Long-term path to Italian and EU citizenship." }
                        ]}
                    />

                    <DetailsSection
                        title="Process to Apply"
                        items={
                            [
                                { text: "Consultation & Eligibility Check" },
                                { text: "Select Investment Option (startup, bonds, business, or donation)" },
                                { text: "Apply for Nulla Osta — pre-approval by the Italian Investor Visa Committee" },
                                { text: "Visa Application at consulate" },
                                { text: "Residency Permit Issuance in Italy" },
                                { text: "Renewals — extend residency permit while maintaining investment" }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Timeline",
                                    duration: "",
                                    description: ""
                                },
                                {
                                    name: "Setup Costs",
                                    description: ""
                                },
                                {
                                    name: "Capital Requirement",
                                    description: ""
                                },
                                {
                                    name: "Annual Costs",
                                    description: ""
                                },

                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "3–4 months",
                            },
                            {
                                name: "Investment Thresholds",
                                description: "€250,000–€2,000,000 depending on category",
                            },
                            {
                                name: "Additional Costs",
                                description: "Legal, government, and professional fees",
                            },
                        ]}
                    />

                    <FeatureCards
                        title='Why Offshore Advisory?'
                        features={
                            [
                                { text: "Experts in European residency & citizenship programs" },
                                { text: "Assistance with investment structuring, due diligence, and legal setup" },
                                { text: "Strong network in Italy for startups, legal, and financial services" },
                                { text: "Comparative insights: Italy vs Spain vs Greece vs Portugal" },
                                { text: "Full family application & renewal support" }
                            ]
                        }
                        />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking for EU residency through investment?"
                        description="The Italian Golden Visa combines lifestyle, Schengen access, and flexible investment options — with a path to citizenship."
                        buttonText="Book a Golden Visa Italy Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Do I need to live in Italy full-time?",
        content: [
            { type: "answer", text: "No — you only need to maintain your investment, though residency days are required for permanent residency/citizenship." },
        ],
    },
    {
        question: "Can my family apply with me?",
        content: [
            { type: "answer", text: "Yes — includes spouse, children, and dependent parents." },
        ],
    },
    {
        question: "How long to Italian citizenship?",
        content: [
            { type: "answer", text: "10 years (shorter for some applicants, e.g., through marriage or heritage)." },
        ],
    },
    {
        question: "What is the cheapest option?",
        content: [
            { type: "answer", text: "€250,000 investment into an innovative startup." },
        ],
    },
    {
        question: "Do I need to know Italian?",
        content: [
            { type: "answer", text: "Not for residency, but required for citizenship." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We invested in an Italian startup to qualify for the Golden Visa. Offshore Advisory managed the full application and Nulla Osta approval.",
        author: "Roberto M.",
        role: "Investor"
    },
    {
        quote: "Italy gave us EU residency and Schengen mobility. Offshore Advisory guided us through every step.",
        author: "Nadia K.",
        role: "Entrepreneur"
    }
];


